// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_status__3haab {
  color: #ffc107;
  font-size: 12px;
  font-weight: 500;
  margin: 0px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--rs_yellow_10, #fff9e7);
  white-space: pre;
}

.style_new__Vv1Km {
  color: #757575;
  background: #f5f5f5;
}

.style_inProgress__mfHo7 {
  color: #ffc107;
  background: #fff9e7;
}

.style_contacted__z3uqu {
  color: #220d77;
  background: #e9e7f2;
}

.style_hired__R6i\\+1 {
  color: #e6f6ec;
  background: #00a43b;
}

.style_rejected__D60-9 {
  color: #fff1ef;
  background: #d84315;
}

.style_spam__IvHYS {
  color: #fff1ef;
  background: lightgray;
}

.style_TasksTable__T8\\+Ta,
.style_nameAndLogo__LXuiW {
  display: flex;
  align-items: center;
}
.style_TasksTable__T8\\+Ta p,
.style_nameAndLogo__LXuiW p {
  margin: 0;
}
.style_TasksTable__T8\\+Ta img,
.style_nameAndLogo__LXuiW img {
  margin-right: 10px;
  border-radius: 5px;
}
.style_TasksTable__T8\\+Ta .style_nameAndLogo__LXuiW p,
.style_TasksTable__T8\\+Ta .style_jobType__7SNWx p,
.style_nameAndLogo__LXuiW .style_nameAndLogo__LXuiW p,
.style_nameAndLogo__LXuiW .style_jobType__7SNWx p {
  margin: 0;
}
.style_TasksTable__T8\\+Ta .style_image-card__HeTYZ img,
.style_nameAndLogo__LXuiW .style_image-card__HeTYZ img {
  border-radius: 10px;
}
.style_TasksTable__T8\\+Ta .style_showFilesInvoice__yIjg8,
.style_nameAndLogo__LXuiW .style_showFilesInvoice__yIjg8 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
}
.style_TasksTable__T8\\+Ta .style_fileCont__W-yLs,
.style_nameAndLogo__LXuiW .style_fileCont__W-yLs {
  position: relative;
}
.style_TasksTable__T8\\+Ta .style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__fXdkl,
.style_nameAndLogo__LXuiW .style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__fXdkl {
  align-items: baseline;
}
.style_TasksTable__T8\\+Ta .style_statusOrders__orRC-,
.style_nameAndLogo__LXuiW .style_statusOrders__orRC- {
  display: flex;
  align-items: center;
}
.style_TasksTable__T8\\+Ta .style_statusOrders__orRC- .style_space__KAUqi,
.style_nameAndLogo__LXuiW .style_statusOrders__orRC- .style_space__KAUqi {
  margin-right: 5px;
}

.style_logo__SyYqm {
  width: 35px;
  margin-right: 1em;
}

.style_EnhancedTableToolbar__sNP8d .style_sortAndFilters__VBMNf {
  display: flex;
  justify-content: flex-end;
}

.style_filterDrawer__Bl7Wr .style_drawerContainer__rGZER {
  width: 20vw;
  min-width: 230px;
  margin-top: 60%;
}
.style_filterDrawer__Bl7Wr .style_drawerContainer__rGZER .style_header__ny\\+DA {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.style_filterDrawer__Bl7Wr .style_drawerContainer__rGZER form > div {
  margin-top: 20px;
}
.style_filterDrawer__Bl7Wr .style_drawerContainer__rGZER .style_clearButt__Kecl9 {
  margin-top: 20px;
  height: 3.5em;
}

@media (max-width: 768px) {
  * {
    font-size: 10px;
  }
}
.style_sortby__yoDzO {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  width: fit-content;
  text-align: center;
  border-right: solid rgba(161, 158, 158, 0.5) 1px;
  border-left: solid rgba(161, 158, 158, 0.5) 1px;
}
.style_sortby__yoDzO label {
  margin-right: 10px;
  margin-left: 10px;
}
.style_sortby__yoDzO .style_css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root__j-Cqx:before {
  border-bottom: none;
}
.style_sortby__yoDzO #style_demo-simple-select__GDV1z {
  margin-top: 3px;
}

.style_removeIcon__KYWEv {
  cursor: pointer;
  transition: transform 0.2s;
}
.style_removeIcon__KYWEv:hover {
  transform: scale(1.2);
}
.style_removeIcon__KYWEv:active {
  transform: scale(0.9);
}

.style_css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root__eINyR:before {
  border-bottom: none;
}

.style_searchBy__NWGo3 {
  border-left: none;
}`, "",{"version":3,"sources":["webpack://./src/views/Orders/table/RowRender/style.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAIA;EACE,cAAA;EACA,qBAAA;AADF;;AASA;;EAEE,aAAA;EACA,mBAAA;AANF;AAOE;;EACE,SAAA;AAJJ;AAME;;EACE,kBAAA;EACA,kBAAA;AAHJ;AAQI;;;;EACE,SAAA;AAHN;AAOE;;EACE,mBAAA;AAJJ;AAOE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAJJ;AAOE;;EACE,kBAAA;AAJJ;AAOE;;EACE,qBAAA;AAJJ;AAOE;;EACE,aAAA;EACA,mBAAA;AAJJ;AAKI;;EACE,iBAAA;AAFN;;AAMA;EACE,WAAA;EACA,iBAAA;AAHF;;AAOE;EACE,aAAA;EACA,yBAAA;AAJJ;;AASE;EAME,WAAA;EACA,gBAAA;EACA,eAAA;AAXJ;AAII;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAFN;AAOI;EACE,gBAAA;AALN;AAOI;EACE,gBAAA;EACA,aAAA;AALN;;AAUA;EACE;IACE,eAAA;EAPF;AACF;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,kBAAA;EAEA,gDAlGW;EAmGX,+CAnGW;AA0Fb;AAWE;EACE,kBAAA;EACA,iBAAA;AATJ;AAWE;EACE,mBAAA;AATJ;AAWE;EACE,eAAA;AATJ;;AAaA;EACE,eAAA;EACA,0BAAA;AAVF;AAWE;EACE,qBAAA;AATJ;AAWE;EACE,qBAAA;AATJ;;AAaA;EACE,mBAAA;AAVF;;AAYA;EACE,iBAAA;AATF","sourcesContent":[".status {\n  color: #ffc107;\n  font-size: 12px;\n  font-weight: 500;\n  margin: 0px;\n  display: flex;\n  padding: 4px 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 100px;\n  background: var(--rs_yellow_10, #fff9e7);\n  white-space: pre;\n}\n\n.chanelChip {\n}\n\n.new {\n  color: #757575;\n  background: #f5f5f5;\n}\n\n.inProgress {\n  color: #ffc107;\n  background: #fff9e7;\n}\n\n.contacted {\n  color: #220d77;\n  background: #e9e7f2;\n}\n\n.hired {\n  color: #e6f6ec;\n  background: #00a43b;\n}\n\n.rejected {\n  color: #fff1ef;\n  background: #d84315;\n}\n.spam {\n  color: #fff1ef;\n  background: lightgray;\n}\n$borderSide: solid\n  rgba(\n    $color: #a19e9e,\n    $alpha: 0.5,\n  )\n  1px;\n.TasksTable,\n.nameAndLogo {\n  display: flex;\n  align-items: center;\n  p {\n    margin: 0;\n  }\n  img {\n    margin-right: 10px;\n    border-radius: 5px;\n  }\n\n  .nameAndLogo,\n  .jobType {\n    p {\n      margin: 0;\n    }\n  }\n\n  .image-card img {\n    border-radius: 10px;\n  }\n\n  .showFilesInvoice {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 5%;\n  }\n\n  .fileCont {\n    position: relative;\n  }\n\n  .css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar {\n    align-items: baseline;\n  }\n\n  .statusOrders {\n    display: flex;\n    align-items: center;\n    .space {\n      margin-right: 5px;\n    }\n  }\n}\n.logo {\n  width: 35px;\n  margin-right: 1em;\n}\n\n.EnhancedTableToolbar {\n  .sortAndFilters {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.filterDrawer {\n  .drawerContainer {\n    .header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n    width: 20vw;\n    min-width: 230px;\n    margin-top: 60%;\n    form > div {\n      margin-top: 20px;\n    }\n    .clearButt {\n      margin-top: 20px;\n      height: 3.5em;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  * {\n    font-size: 10px;\n  }\n}\n.sortby {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-top: 5px;\n  width: fit-content;\n  text-align: center;\n\n  border-right: $borderSide;\n  border-left: $borderSide;\n\n  label {\n    margin-right: 10px;\n    margin-left: 10px;\n  }\n  .css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n    border-bottom: none;\n  }\n  #demo-simple-select {\n    margin-top: 3px;\n  }\n}\n\n.removeIcon {\n  cursor: pointer;\n  transition: transform 0.2s;\n  &:hover {\n    transform: scale(1.2);\n  }\n  &:active {\n    transform: scale(0.9);\n  }\n}\n\n.css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n  border-bottom: none;\n}\n.searchBy {\n  border-left: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `style_status__3haab`,
	"new": `style_new__Vv1Km`,
	"inProgress": `style_inProgress__mfHo7`,
	"contacted": `style_contacted__z3uqu`,
	"hired": `style_hired__R6i+1`,
	"rejected": `style_rejected__D60-9`,
	"spam": `style_spam__IvHYS`,
	"TasksTable": `style_TasksTable__T8+Ta`,
	"nameAndLogo": `style_nameAndLogo__LXuiW`,
	"jobType": `style_jobType__7SNWx`,
	"image-card": `style_image-card__HeTYZ`,
	"showFilesInvoice": `style_showFilesInvoice__yIjg8`,
	"fileCont": `style_fileCont__W-yLs`,
	"css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar": `style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__fXdkl`,
	"statusOrders": `style_statusOrders__orRC-`,
	"space": `style_space__KAUqi`,
	"logo": `style_logo__SyYqm`,
	"EnhancedTableToolbar": `style_EnhancedTableToolbar__sNP8d`,
	"sortAndFilters": `style_sortAndFilters__VBMNf`,
	"filterDrawer": `style_filterDrawer__Bl7Wr`,
	"drawerContainer": `style_drawerContainer__rGZER`,
	"header": `style_header__ny+DA`,
	"clearButt": `style_clearButt__Kecl9`,
	"sortby": `style_sortby__yoDzO`,
	"css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root": `style_css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root__j-Cqx`,
	"demo-simple-select": `style_demo-simple-select__GDV1z`,
	"removeIcon": `style_removeIcon__KYWEv`,
	"css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root": `style_css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root__eINyR`,
	"searchBy": `style_searchBy__NWGo3`
};
export default ___CSS_LOADER_EXPORT___;
